import { useState, useEffect, useMemo } from 'react';
import { Outlet, useLocation, useNavigate, useLoaderData } from 'react-router';

import type { DashboardData, Template } from '@/types/monitoringTypes';

const nowDate = new Date().toISOString().slice(0, 16);
const nowMinus30Days = new Date(new Date().setDate(new Date().getDate() - 30))
  .toISOString()
  .slice(0, 16);

const Monitoring = (): React.JSX.Element | null => {
  const location = useLocation();
  const navigate = useNavigate();
  const loaderDashboard: DashboardData = useLoaderData();
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(loaderDashboard);

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const from = searchParams.get('from');
  const to = searchParams.get('to');

  useEffect(() => {
    if (dashboardData) {
      let newUrl = `${location.pathname}?from=${nowMinus30Days}&to=${nowDate}`;
      const templates = dashboardData.templating.filter(
        (template: Template) => template.hide === 0
      );
      templates.forEach((template: Template) => {
        const value = searchParams.get(template.name) ?? template.current.value;
        newUrl += `&${template.name}=${value}`;
      });
      navigate(newUrl, { replace: true });
    }
  }, [dashboardData, location.pathname, navigate, searchParams]);

  return dashboardData && from && to ? (
    <div>
      <Outlet context={[dashboardData, setDashboardData]} />
    </div>
  ) : null;
};

export default Monitoring;
